import { createTheme, PaletteOptions, responsiveFontSizes, Theme } from '@mui/material/styles';
import gray from '@mui/material/colors/grey';

// Dark mode only palette
const DarkPalette: PaletteOptions = {
    mode: 'dark',
    primary: {
        main: '#00A39B',
        light: '#E5E5E5',
        dark: '#007375'
    }
};

// Dark mode only theme configuration

const DarkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#00A39B',
            light: '#E5E5E5',
            dark: '#007375'
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    ...(ownerState.variant === 'contained' &&
                        ownerState.color === 'primary' && {
                            color: '#fff'
                        })
                })
            }
        },
        MuiChip: {
            styleOverrides: {
                labelSmall: {
                    lineHeight: '18px'
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: {
                'main.MuiBox-root': {
                    backgroundColor: '#121212'
                },
                body: {
                    backgroundColor: '#121212'
                }
            }
        },
        MuiTypography: {
            defaultProps: {
                variant: 'body2'
            }
        }
    }
});

const DarkThemeWithResponsiveFontSizes = responsiveFontSizes(DarkTheme);

export { DarkThemeWithResponsiveFontSizes };
